import React from 'react';
import { INTERNATIONAL_CHECKOUT } from '../../data/bookingExperienceData';
import './international-checkout.scss';

const KHALTI_LOGO = 'https://khaltibyime.khalti.com/wp-content/uploads/2025/07/Logo-for-Blog.png';
const ESEWA_LOGO = 'https://esewa.com.np/common/images/esewa_logo.png';

/**
 * Shared “pay with your foreign card” message — home hero, booking hub, flights search.
 * @param {'hero'|'panel'|'inline'} layout
 */
function InternationalCardBanner({
	layout = 'inline',
	panelTop = false,
	compact = false,
	showLocalWallets = true,
	showScopes = false,
	headlineAsH1 = false,
}) {
	const {
		eyebrow,
		headlineBefore,
		headlineStrong,
		sub,
		scopeLabels,
		cardBrands,
	} = INTERNATIONAL_CHECKOUT;

	const rootClass = [
		'intl-checkout',
		layout === 'hero' && 'intl-checkout--hero',
		layout === 'panel' && 'intl-checkout--panel',
		panelTop && 'intl-checkout--panel-top',
		compact && 'intl-checkout--compact',
	]
		.filter(Boolean)
		.join(' ');

	const hideLocal = !showLocalWallets || layout === 'hero';
	const HeadlineTag = headlineAsH1 ? 'h1' : 'p';

	return (
		<div className={rootClass} aria-label="International card payment at checkout">
			<div className="intl-checkout__cards">
				<span className="intl-checkout__eyebrow">{eyebrow}</span>
				<HeadlineTag className="intl-checkout__headline">
					{headlineBefore} <strong>{headlineStrong}</strong>
				</HeadlineTag>
				{!compact && <p className="intl-checkout__sub">{sub}</p>}
				{showScopes && scopeLabels?.length > 0 && (
					<ul className="intl-checkout__scopes" aria-label="What you can book">
						{scopeLabels.map((label) => (
							<li key={label} className="intl-checkout__scope">
								{label}
							</li>
						))}
					</ul>
				)}
				<div className="intl-checkout__card-badges" aria-hidden="true">
					{cardBrands.map((brand) => (
						<span key={brand} className="intl-checkout__card-badge">
							{brand}
						</span>
					))}
				</div>
			</div>
			{!hideLocal && (
				<div
					className={`intl-checkout__local${
						panelTop ? ' intl-checkout__local--secondary' : ''
					}`}
				>
					<span className="intl-checkout__local-label">
						{panelTop ? 'Local wallets (optional)' : 'In Nepal you can also use'}
					</span>
					<span className="intl-checkout__logos">
						<img
							src={ESEWA_LOGO}
							alt="eSewa"
							className="intl-checkout__logo intl-checkout__logo--esewa"
							loading="lazy"
						/>
						<img
							src={KHALTI_LOGO}
							alt="Khalti"
							className="intl-checkout__logo intl-checkout__logo--khalti"
							loading="lazy"
						/>
					</span>
				</div>
			)}
		</div>
	);
}

export default InternationalCardBanner;
